export abstract class FileSaver {
	abstract save(data: Blob, fileName: string): void;
}
